import React, { Component } from "react";
import { connect } from "react-redux";
import windowSize from "../libs/reactWindowSize";
import { withScenePosition, getFontSize } from "../scenePosition";
import { Link } from "react-router-dom";
import { Translate } from "react-localize-redux";

class Tooltip extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.onNextStep = this.onNextStep.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    let {
      title,
      copy,
      instruction,
      placement,
      windowWidth,
      steps,
      open,
      hasButton,
      buttonText,
      to,
      toLabel,
      paragraphExtra,
      paragraphLink,
      paragraphLinkLabel,
      overrides,
      activeLanguage
    } = props;

    let fontSize = getFontSize(windowWidth) + "px";

    let derivedState = {
      ...state,
      title: title,
      copy: copy,
      instruction: instruction,
      placement: placement,
      fontSize: fontSize,
      showSteps: steps,
      open: open || false,
      stepCount: steps ? steps.length + 1 : undefined,
      hasButton: hasButton,
      buttonText: buttonText,
      to: to,
      toLabel: toLabel,
      paragraphExtra: paragraphExtra,
      paragraphLink: paragraphLink,
      paragraphLinkLabel: paragraphLinkLabel
    };

    return derivedState;
  }

  onNextStep() {
    let { steps, step, dispatch } = this.props;

    if (step.started) {
      if (step.index + 1 >= step.steps.length) {
        dispatch({
          type: "step/FINISH"
        });
      } else {
        dispatch({
          type: "step/NEXT"
        });
      }
    } else {
      dispatch({
        type: "step/START",
        payload: {
          steps: steps,
          id: this.state.id
        }
      });

      this.setState({
        activated: true
      });
    }
  }

  calculateMargin(placement) {
    switch (placement) {
      case "top":
        return `0 0 1.25em 0`;
      case "bottom":
        return `1.25em 0 0 0`;
      case "left":
        return `0 1.25em 0 0`;
      case "right":
        return `0 0 0 1.25em`;
      default:
        return "0";
    }
  }

  render() {
    const {
      placement,
      title,
      copy,
      instruction,
      fontSize,
      open,
      hasButton,
      buttonText,
      to,
      toLabel,
      paragraphExtra,
      paragraphLink,
      paragraphLinkLabel
    } = this.state;
    const { hover } = this.props;
    const {
      top,
      left,
      width,
      height,
      type,
      onMouseOver,
      onMouseOut
    } = this.props;
    return (
      <div
        className={`tooltip ${placement} ${type} ${open ? "open" : ""}  ${
          hover ? "hover" : ""
        }`}
        style={{
          top: top,
          left: left,
          width: width,
          height: height,
          fontSize: fontSize,
          margin: this.calculateMargin(placement)
        }}
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
      >
        {title ? (
          <h3>
            <Translate id={title} />
          </h3>
        ) : (
          undefined
        )}
        {copy ? (
          <p>
            <span>
              <Translate id={copy} />
            </span>
            {!!paragraphLink && (
              <Link
                to={{ pathname: paragraphLink, search: window.location.search }}
              >
                <em>
                  <Translate id={paragraphLinkLabel} />
                </em>
              </Link>
            )}
            <span>
              {paragraphExtra ? <Translate id={paragraphExtra} /> : undefined}
            </span>
          </p>
        ) : (
          undefined
        )}
        {to ? (
          <div>
            <a
              className="tooltip-text-link"
              href={window.public_url + to}
              target="_blank"
              onMouseOver={onMouseOver}
              onMouseOut={onMouseOut}
            >
              <Translate id={toLabel} />{" "}
              <i className="fa fa-external-link" aria-hidden="true" />
            </a>
          </div>
        ) : (
          undefined
        )}
        {instruction ? (
          <p className="instruction-copy">
            <Translate id={instruction} />
          </p>
        ) : (
          undefined
        )}
        {hasButton ? (
          <div className="tooltip-text-link" onClick={this.onNextStep}>
            <Translate id={buttonText} />
          </div>
        ) : (
          undefined
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    scene: state.scene,
    step: state.step
  };
}

Tooltip.defaultProps = {
  type: "standard",
  title: "",
  copy: "",
  to: null,
  toLabel: "",
  instruction: "",
  hasButton: false,
  paragraphExtra: "",
  paragraphLink: null,
  paragraphLinkLabel: ""
};

export default windowSize(connect(mapStateToProps)(withScenePosition(Tooltip)));



// WEBPACK FOOTER //
// ./src/components/Tooltip.jsx